// src/features/insurancePlan/page/PlanGroup

import DynamicTable from '@/common/components/DynamicTable/DynamicTable';
import type { ColumnsType } from 'antd/es/table';
import { useTranslation } from 'react-i18next';
import { API_ENDPOINTS, QUERY_KEYS } from '../../api/apiEndpoints';
import type { PlanSetupType } from '../../types/insurancePlanTypes';
import PlanCloneModal from '../../pages/SetupPlan/components/ClonePlanModal';
import StatusTag from '../../../../common/components/Status';



const PlanSetup = () => {
    const { t } = useTranslation();

    // Define columns for the PlanGroup table
    const PlanGroupColumns: ColumnsType<PlanSetupType> = [
        { title: "Name", dataIndex: "name", key: "name", width: "100" },
        { title: "Description", dataIndex: "description", key: "description", width: 350 },
        { title: "Company", dataIndex: "companyName", key: "companyName", render: (text) => text ?? 'N/A' },
        { title: "Currency Code", dataIndex: "currencyISOCode", width: 130, key: "currencyISOCode", render: (text) => text ?? 'N/A' },
        {
            title: "Active",
            dataIndex: "isActive",
            key: "isActive",
            render: (isActive: boolean) => (
                <StatusTag status={isActive ? "Yes" : "No"} />
            ),
        },
    ];

    const myActions = [
        {
            render: (record: PlanSetupType) => {
                    return (
                        <PlanCloneModal
                            planId={record.id}
                            planName={record.name}
                            apiUrl={API_ENDPOINTS.INSURANCEPLAN.CLONE_PLAN}
                            queryKey={QUERY_KEYS.INSURANCEPLAN.PLANS}
                        />
                    );
            },
        },
    ];

    return (
        <div>
           
            <DynamicTable<PlanSetupType>
                tableTitle={"Plan Setup"}
                dataApiUrl={API_ENDPOINTS.INSURANCEPLAN.GET_PLAN} // Your API endpoint for fetching menus
                baseQueryKey={QUERY_KEYS.INSURANCEPLAN.PLANS} // Unique query key for menus
                columns={PlanGroupColumns}
                showActions={{
                    //edit: (record) => record.isActive, // Edit if active
                    delete: (record) => !record.isActive, // Delete if not active
                    view:(record) => !record.isActive, // View if not active
                }}
                deleteBaseUrl={API_ENDPOINTS.INSURANCEPLAN.DELETE_PLAN}
                deletePayloadField={"name"}
                deleteSecondQueryKey={['dropdownData', 'companieswithoutplan']}
                customActions={myActions}
                // Pass the fields you want the search bar to filter
                filterConfigs={[
                    { field: "name", placeholder: t('Search by name') },
                    // {
                    //     field: 'groupId',
                    //     type: 'select',
                    //     placeholder: t("Select group"),
                    //     showSearch: true,
                    //     dynamicOptions: {
                    //         url: API_ENDPOINTS.INSURANCEPLAN.SEARCH_PLANGROUP,
                    //         method: "POST",
                    //         transformData:
                    //             "(apiResponse) => apiResponse.data.map((item) => ({ label: item.name, value: item.id }))",
                    //     },
                    // },
                    {
                        field: "Print",
                        type: "export",
                        exportOptions: {
                            url: API_ENDPOINTS.INSURANCEPLAN.EXPORT_PLANSETUP,
                            fileName: "PlanSetup",
                            fileType: "excel", // "csv" 
                            defaultPayload: {},
                            columns: [
                                { header: "Name", key: "name" },
                                { header: "Description", key: "description" },
                                { header: "Group Name", key: "groupName" },
                                { header: "Currency Code", key: "currencyISOCode" },
                                { header: "Active", key: "isActive", transform: (val: boolean) => val === true ? "Active" : "Inactive" },
                            ]
                        }
                    }
                ]}
            />
        </div>
    );
};

export default PlanSetup;